import styled from 'styled-components';

export const Space = styled.div<{ $size: number }>`
    height: ${props => props.$size}px;
`;
